import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  ReactNode,
} from "react";

export type PlayerContextType = {
  playingVideoId: string | number | null;
  setPlayingVideoId: Dispatch<SetStateAction<string | number | null>>;
};

const PlayerContext = createContext<PlayerContextType>({
  playingVideoId: null,
  setPlayingVideoId: (newVal) => console.log(newVal),
});

interface Props {
  children?: ReactNode;
}

const PlayerProvider: React.FC<Props> = ({ children }) => {
  const [playingVideoId, setPlayingVideoId] = useState<string | number | null>(
    null
  );

  return (
    <PlayerContext.Provider
      value={{
        playingVideoId,
        setPlayingVideoId,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export function usePlayerContext() {
  const context = useContext(PlayerContext);
  if (context === undefined) {
    throw new Error(`usePlayerContext must be used within a PlayerProvider`);
  }
  return context;
}

export default PlayerProvider;
